import { max } from 'lodash';

export function getMetaData(data) {
  if (data.length) {
    data.forEach((_data) => {
      delete _data['data'];
    });
  }
  return data;
}

export function getMaxDataPoint(data) {
  if (data.length) {
    const result = [];
    data.forEach((_data) => {
      if (_data.maxValue) {
        result.push(parseFloat(_data.maxValue));
      }
      if (_data.hiAlarm) {
        result.push(_data.hiAlarm);
      }
    });
    return max(result);
  }
}
